const appConfig = {
    impressUrl: import.meta.env?.VITE_IMPRESS_URL ?? "",
    impressAccessToken: import.meta.env?.VITE_IMPRESS_ACCESS_TOKEN,
    apiUrl: import.meta.env?.VITE_API_URL,
    timezone: import.meta.env?.TIMEZONE || "Asia/Bangkok"
};

export default appConfig;
